import { ThemeConfig } from 'antd';

export const theme: ThemeConfig = {
  token: {
    fontFamily: 'Rubik',
    colorPrimary: '#4556CE',
  },
};
